import { useCallback, useState } from "react";
import { processEmail as processEmailApi } from "../services/archiveApi";
import { convertToGraphId } from "../../shared/utils/officeHelpers";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function getBodyPreview(maxLength = 160) {
  return new Promise((resolve) => {
    try {
      Office.context.mailbox.item.body.getAsync(
        Office.CoercionType.Text,
        (result) => {
          if (result.status === Office.AsyncResultStatus.Succeeded) {
            const text = (result.value || "").replace(/\s+/g, " ").trim();
            resolve(text.length > maxLength ? text.substring(0, maxLength) + "..." : text);
          } else {
            resolve("");
          }
        }
      );
    } catch {
      resolve("");
    }
  });
}

export default function useEmailArchive() {
  const [status, setStatus] = useState("idle");
  const [activeStep, setActiveStep] = useState(-1);
  const [result, setResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const reset = useCallback(() => {
    setStatus("idle");
    setActiveStep(-1);
    setResult(null);
    setErrorMessage(null);
  }, []);

  const processEmail = useCallback(async ({ messageId, userEmail, projectId }) => {
    setStatus("processing");
    setActiveStep(0);
    setErrorMessage(null);

    try {
      const previewText = await getBodyPreview();

      await delay(900);
      setActiveStep(1);
      await delay(1000);
      setActiveStep(2);

      const response = await processEmailApi({
        emailId: convertToGraphId(messageId),
        userEmail,
        projectId,
        previewText,
      });

      await delay(700);
      setActiveStep(3);
      setResult(response);
      setStatus("success");

      return response;
    } catch (error) {
      setStatus("error");
      setActiveStep(-1);
      setResult(null);
      setErrorMessage(error?.message || "Filing failed.");
      throw error;
    }
  }, []);

  return {
    status,
    activeStep,
    result,
    errorMessage,
    isProcessing: status === "processing",
    reset,
    processEmail,
  };
}
